import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/layout'
import QueryPage from '../views/userpage/QueryPage'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Layout,
    redirect: '/home/QueryPage',
    children: [
      {
        path: 'QueryPage',
        component: QueryPage
      },
    ]
  },
]

const router = new VueRouter({
  routes,
})

export default router
